import { createContext, useContext } from 'react'
import { type ReviewsListStore } from 'pages/reviews/store'

export const ReviewsListContext = createContext<ReviewsListStore | null>(null)

export const useReviewsListContext = () => {
  const context = useContext(ReviewsListContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with ReviewsListContext')

  return context
}
